require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./responsive-web-design-applied-visual-design-create-visual-balance-using-the-text-align-property.json") })
        }
      }, "path---responsive-web-design-applied-visual-design-create-visual-balance-using-the-text-align-property");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---responsive-web-design-applied-visual-design-create-visual-balance-using-the-text-align-property!./.cache/json/responsive-web-design-applied-visual-design-create-visual-balance-using-the-text-align-property.json
// module id = 2547
// module chunks = 231608221292675